import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders, buildError, API } from '../../api/apis';
import { ApiResponse, DescribeTenantSettingsResponse, UpdateTenantSettingsRequest, UpdateTenantSettingsResponse } from '../../interfaces/interfaces';

export const gsettingsService = createApi({
  reducerPath: 'gsettingsApi',
  tagTypes: ['GlobalSettings'],
  baseQuery: fetchBaseQuery({
    prepareHeaders: prepareHeaders,
  }),
  endpoints: (builder) => ({
    getGlobalSettings: builder.query({
      query: () => API.FETCH_GSETTINGS(),
      providesTags: () => [{ type: 'GlobalSettings', id: 'DESCRIBE' }],
      transformResponse: (response: ApiResponse) => {
        return response.Response as DescribeTenantSettingsResponse;
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
    }),
    updateGlobalSettings: builder.mutation({
      query: (requestUpdateSettings: UpdateTenantSettingsRequest) => ({
        url: API.UPDATE_GSETTINGS(),
        method: 'PATCH',
        body: requestUpdateSettings,
      }),
      invalidatesTags: [{ type: 'GlobalSettings', id: 'DESCRIBE' }],
      transformResponse: (response: ApiResponse) => {
        return response.Response as UpdateTenantSettingsResponse;
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
    }),
  }),
});

export const { useGetGlobalSettingsQuery, useUpdateGlobalSettingsMutation } = gsettingsService;
